import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { DatePicker } from "Shared/Components/Form/CustomFormComponent/DatePicker";
import { Box, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

const orderResources = Resources.base.order.editForm;

export const DateNextActionForm = () => {
	const { t } = useResource();

	const {
		control,
		formState: { errors },
		setValue,
	} = useFormContext();

	const handleResetDate = useCallback(() => {
		setValue("dateNextAction", null, { shouldDirty: true });
	}, [setValue]);

	return (
		<>
			<Stack columnGap={2} direction="row" alignItems="start">
				<Box width="100%">
					<DatePicker
						name="dateNextAction"
						control={control}
						errors={errors}
						minDate={dayjs()}
					/>
				</Box>
			</Stack>
			<Box onClick={handleResetDate} sx={{ mt: 1, cursor: "pointer" }}>
				<Typography variant="caption" color="primary">
					{t(orderResources.reset)}
				</Typography>
			</Box>
		</>
	);
};
